import type { NavigationGuard } from 'vue-router'

import { resolvePermissionAccess } from '../permissionAccess'
import { readPermissionSnapshot, type PermissionSnapshot } from '../permissionSnapshot'

/** The RBAC reads permissionGuard needs (injected as fakes in unit tests — no Vue runtime). */
export type PermissionGuardSnapshot = PermissionSnapshot
// Ledger A4: every authorization field comes from module 07's `useRbac()`. Session status is
// read only to prevent a cold deep-link decision from being made against the pre-ready empty map.
const readLive = (): PermissionGuardSnapshot => readPermissionSnapshot()

// RBAC gate (legacy :241–243 + :87–92 + the Scorecards beforeEnter re-expressed as
// meta.permission:'sysadmin'; golden rows 30 + 10*). Return-value style, never next().
export const createPermissionGuard =
  (read: () => PermissionGuardSnapshot = readLive): NavigationGuard =>
  (to) => {
    const snapshot = read()
    // Empty pre-ready RBAC is neither a grant nor a denial. Preserve the target so AppLayout can
    // mount its splash; the coordinator revalidates with this same resolver after hydration.
    return snapshot.status === 'ready' ? resolvePermissionAccess(to, snapshot) : true
  }
export const permissionGuard: NavigationGuard = createPermissionGuard()
